// Selectors for finding focusable elements
export const FOCUSABLE_SELECTORS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'details',
  '[contenteditable="true"]',
  'audio[controls]',
  'video[controls]',
  '[tabindex]:not([tabindex="-1"]):not([tabindex=""])',
];

// Navigation action constants
export const NAVIGATION_ACTION = {
  PARENT: 'PARENT',
  CHAIN_FORWARD: 'CHAIN_FORWARD',
  CHAIN_BACKWARD: 'CHAIN_BACKWARD',
};

export const DEFAULT_PAGE_JUMP = 10;

export const KEYS = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ENTER: 'Enter',
  SPACE: ' ',
  TAB: 'Tab',
  HOME: 'Home',
  END: 'End',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  ESCAPE: 'Escape',
};
